import { useUpdateOrdenTrabajo, useUpdatePreventa } from "@/shared/actions/erp";
import { ContratosActionsKeysEnum } from "@/shared/constants";
import { erpApi } from "@/shared/axios/erp-api";
import { urlBackend } from "@/shared/constants";
import { OrdenTrabajoGenerateDocuments } from "@/shared/interfaces";
import { useUiStore } from "@/store/ui";
import { useQueryClient } from "@tanstack/react-query";
import { Button } from "@mui/material";


interface ButtonGenerarDocumentos{
    ordenTrabajoId:string;
    preventaId?:string;
    enableReload?:boolean;
    signatureInDocs?:boolean;
    generateContract?:boolean;
    getResDataFunction?:(res:any)=>void;
}
/**
 * Recibe el ID de la orden de trabajo y genera nuevamente los documentos
 * @param {string} ordenTrabajoId - ID de Orden de Trabajo.
 * @returns {void}
 * 
 */
export default function ButtonGenerarDocumentos({
    ordenTrabajoId,
    preventaId,
    enableReload=false,
    signatureInDocs=false,
    generateContract=false,
    getResDataFunction
}:ButtonGenerarDocumentos) {
    const setAlert = useUiStore(s => s.setAlert);
    const queryClient = useQueryClient();
    
    const generateDocuments = useUpdateOrdenTrabajo<OrdenTrabajoGenerateDocuments>({
        enableRedirect: false,
    })
    const generateContractDocument = useUpdatePreventa({
        enableRedirect: false,
    })
    
    const generarDocumentos = async (ordenTrabajoId: string) => {
        let auxDataAnexos : any = {
            generar_anexos: true
        }
        let auxDataContract:any = {
            generar_pdf_contrato:true
        }
        if(signatureInDocs){
            auxDataAnexos.os = true
            auxDataContract.os = true
        }
        
        if(generateContract && preventaId){
            await generateContractDocument.mutateAsync({
                id: preventaId!,
                data: auxDataContract,
            })
        }

        const res = await generateDocuments.mutateAsync({
            id: ordenTrabajoId!,
            data: auxDataAnexos,
        })

        if(preventaId){
            const { post } = erpApi();
            await post(
                `${urlBackend}api/v1/preventas/reparar-firma/`,
                { accion: 'regenerar_manual', preventas: [preventaId] },
                true
            );
        }

        // Invalidar caché de contrato para que se refresquen los datos
        queryClient.invalidateQueries({ queryKey: [ContratosActionsKeysEnum.CONTRATO] });

        setAlert(true, 'Documentos generados correctamente', 'success');
        getResDataFunction?getResDataFunction(res):null

        if(enableReload && res.code==200){
            setTimeout(() => {
                window.location.reload();
            }, 2000);
        }
    }
  return (
    <Button
        variant="contained"
        onClick={() => {
            generarDocumentos(ordenTrabajoId!)
        }}
    >Generar documentos</Button>
  )
}

